// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RFCField_container__5asEU {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
}

.RFCField_input__2pZmR {
  height: 40px;
  border: solid 1px #666666;
  border-radius: 4px;
  margin-top: 8px;
  padding: 9px 16px;
}

.RFCField_input-rfc__xwSHu {
  text-transform: uppercase;
}

.RFCField_error-text__z99qN {
  margin-top: 10px;
  color: #c9423c;
  font-size: 12px;
}

.RFCField_input-error__ezJmb {
  border: solid 1px #c9423c;
}

.RFCField_input-error__ezJmb:focus-within {
  outline: none !important;
  border: solid 2px #c9423c;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/RFCField/RFCField.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;;AAKA;EAAa,yBAAA;AADb;;AAGA;EACI,gBAAA;EACA,cAAA;EACA,eCtBK;ADsBT;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,wBAAA;EACA,yBAAA;AAAJ","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.container {\n    display: flex;\n    flex-direction: column;\n    margin-top: 18px;\n}\n\n.input {\n    height: 40px;\n    border: solid 1px #666666;\n    border-radius: 4px;\n    margin-top: 8px;\n    padding: 9px 16px;\n}\n\n.input-rfc { text-transform: uppercase; }\n\n.error-text {\n    margin-top: 10px;\n    color: colors.$error;\n    font-size: typography.$body-s;\n}\n\n.input-error {\n    border: solid 1px colors.$error;\n}\n\n.input-error:focus-within {\n    outline: none !important;\n    border: solid 2px colors.$error;\n}","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RFCField_container__5asEU`,
	"input": `RFCField_input__2pZmR`,
	"input-rfc": `RFCField_input-rfc__xwSHu`,
	"error-text": `RFCField_error-text__z99qN`,
	"input-error": `RFCField_input-error__ezJmb`
};
export default ___CSS_LOADER_EXPORT___;
